import '../styles/tagsAndMentions.scss';

export default function TopMentionsCard({ mentions }) {
  if (!mentions || mentions?.length === 0) {
    return null;
  }
  return (
    <div className="demographics-card">
      <h2>They mention these accounts</h2>
      <div className="mentions-container">
        {mentions && mentions.slice(0, 10).map((mention, index) => <MentionPill key={index} mention={mention.tag} />)}
      </div>
    </div>
  );
}

const MentionPill = ({ mention }) => {
  return <span className="mention-pill">@{mention}</span>;
};
